var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyringe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.062,27.042l-6.104-6.104c-0.781-0.781-2.047-0.781-2.828,0c-0.781,0.781-0.781,2.047,0,2.828l1.638,1.638L62.5,30.672 l-2.893-2.893c-0.781-0.781-2.047-0.781-2.828,0L38.497,46.061c0,0,0,0-0.001,0.001s0,0-0.001,0.001l-6.787,6.787 c-0.375,0.375-0.586,0.884-0.586,1.414s0.211,1.039,0.586,1.414l2.893,2.893L23.991,69.182c-0.781,0.781-0.781,2.047,0,2.828 c0.391,0.391,0.902,0.586,1.414,0.586s1.024-0.195,1.414-0.586L37.43,61.398l2.893,2.893c0.391,0.391,0.902,0.586,1.414,0.586 s1.024-0.195,1.414-0.586l6.783-6.783c0.001-0.001,0.003-0.002,0.005-0.004c0.001-0.001,0.002-0.003,0.004-0.005l18.279-18.278 c0.375-0.375,0.586-0.884,0.586-1.414s-0.211-1.039-0.586-1.414L65.328,33.5l5.268-5.268l1.638,1.638 c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586C75.843,29.09,75.843,27.823,75.062,27.042z M41.736,60.049 l-5.785-5.785l3.959-3.959l5.785,5.785L41.736,60.049z M48.524,53.261l-5.785-5.785l15.454-15.454l5.785,5.785L48.524,53.261z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyringe);
export default __webpack_public_path__ + "static/media/syringe.f6899c41135d5a37958d13ee09e015cc.svg";
export { ForwardRef as ReactComponent };